import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { ModelOfProductSubgroup } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';
import { useAuth } from 'src/contexts/auth';

export const useListProductSubgroupController = () => {
	const [ProductSubgroupData, setProductSubgroupsData] = useState<ModelOfProductSubgroup[]>([]);
	const [selectedProductSubgroup, setSelectedProductSubgroup] = useState<ModelOfProductSubgroup>();
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const { userAgencyId } = useAuth();

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getProductSubgroups = () => {
		api.get(`subgroups/${userAgencyId}`)
			.then(response => {
				const data = response.data;
				setProductSubgroupsData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeProductSubgroup = (ProductSubgroup: ModelOfProductSubgroup) => {
		setLoading(true);
		api.delete(`subgroups/${ProductSubgroup.ID}`)
			.then(() => {
				getProductSubgroups();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A marca foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getProductSubgroups();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editProductSubgroup = (ProductSubgroup: ModelOfProductSubgroup) => {
		setLoading(true);

		const editedProductSubgroup: ModelOfProductSubgroup = {
			...ProductSubgroup,
		};

		api.put(`subgroups/${selectedProductSubgroup?.ID}`, editedProductSubgroup)
			.then(() => {
				getProductSubgroups();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O subgrupo foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getProductSubgroups();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getProductSubgroups();
	}, []);

	const openDeleteDialog = (ProductSubgroup: ModelOfProductSubgroup) => {
		setDeleteDialog(true);
		setSelectedProductSubgroup(ProductSubgroup);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (ProductSubgroup: ModelOfProductSubgroup) => {
		setEditDialog(true);
		setSelectedProductSubgroup(ProductSubgroup);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfProductSubgroup>({
		initialValues: {
			AX_GRUPO: '',
			DESCRICAO: '',
		},
		onSubmit: values => editProductSubgroup(values),
		validationSchema,
	});

	return {
		getProductSubgroupListController: {
			formik,
			ProductSubgroupData,
			selectedProductSubgroup,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleProductSubgroupListController: {
			removeProductSubgroup,
			editProductSubgroup,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getProductSubgroups,
		},
	};
};
